module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "new-advert"
    }
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('span', [_vm._v("信息流广告 >")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.advertTitle) + "的信息流广告 >")]), _vm._v(" "), (_vm.edit === false) ? _c('span', [_vm._v("新增广告")]) : _vm._e(), _vm._v(" "), (_vm.edit !== false) ? _c('span', [_vm._v("编辑广告")]) : _vm._e(), _vm._v(" "), _c('span', [_c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.saveAdvertInfo(1)
      }
    }
  }, [_vm._v("保存草稿")]), _vm._v(" "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.saveAdvertInfo(0)
      }
    }
  }, [_vm._v("发布")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('el-form', {
    ref: "advertForm",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.advertForm,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "终端：",
      "prop": "osType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.advertForm.osType),
      callback: function($$v) {
        _vm.$set(_vm.advertForm, "osType", $$v)
      },
      expression: "advertForm.osType"
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.advertForm.osType),
      callback: function($$v) {
        _vm.$set(_vm.advertForm, "osType", $$v)
      },
      expression: "advertForm.osType"
    }
  }, [_vm._v("安卓")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.advertForm.osType),
      callback: function($$v) {
        _vm.$set(_vm.advertForm, "osType", $$v)
      },
      expression: "advertForm.osType"
    }
  }, [_vm._v("IOS")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "广告标题：",
      "prop": "description",
      "required": ""
    }
  }, [_c('el-input', {
    staticClass: "flickerTitle",
    attrs: {
      "placeholder": "广告标题（15字以内）"
    },
    model: {
      value: (_vm.advertForm.title),
      callback: function($$v) {
        _vm.$set(_vm.advertForm, "title", $$v)
      },
      expression: "advertForm.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "广告说明：",
      "prop": "description"
    }
  }, [_c('el-input', {
    staticClass: "flickerTitle",
    attrs: {
      "placeholder": "广告说明"
    },
    model: {
      value: (_vm.advertForm.description),
      callback: function($$v) {
        _vm.$set(_vm.advertForm, "description", $$v)
      },
      expression: "advertForm.description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "图片：",
      "prop": "imgUrl"
    }
  }, [_c('el-upload', {
    attrs: {
      "action": _vm.actionUrl,
      "with-credentials": true,
      "accept": "image/*",
      "name": "uploadFile",
      "type": "drag",
      "thumbnail-mode": true,
      "on-error": _vm.handleError,
      "on-success": _vm.handleSuccess
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-dragger__text"
  }, [_vm._v("将文件拖到此处，或\n                        "), _c('em', [_vm._v("点击上传")])])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "等级：",
      "prop": "grade"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.advertForm.grade),
      callback: function($$v) {
        _vm.$set(_vm.advertForm, "grade", $$v)
      },
      expression: "advertForm.grade"
    }
  }, [_vm._v("高")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.advertForm.grade),
      callback: function($$v) {
        _vm.$set(_vm.advertForm, "grade", $$v)
      },
      expression: "advertForm.grade"
    }
  }, [_vm._v("中")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.advertForm.grade),
      callback: function($$v) {
        _vm.$set(_vm.advertForm, "grade", $$v)
      },
      expression: "advertForm.grade"
    }
  }, [_vm._v("低")])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "ad-time",
    attrs: {
      "label": "开始时间：",
      "prop": "startTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": "yyyy/MM/dd",
      "placeholder": "yyyy/MM/dd"
    },
    model: {
      value: (_vm.advertForm.startTime),
      callback: function($$v) {
        _vm.$set(_vm.advertForm, "startTime", $$v)
      },
      expression: "advertForm.startTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "ad-time",
    attrs: {
      "prop": "endTime",
      "label": "结束时间："
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": "yyyy/MM/dd",
      "placeholder": "yyyy/MM/dd"
    },
    model: {
      value: (_vm.advertForm.endTime),
      callback: function($$v) {
        _vm.$set(_vm.advertForm, "endTime", $$v)
      },
      expression: "advertForm.endTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "click-events",
    attrs: {
      "label": "点击事件",
      "prop": "clickType"
    }
  }, [_c('el-radio', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.advertForm.clickType),
      callback: function($$v) {
        _vm.$set(_vm.advertForm, "clickType", $$v)
      },
      expression: "advertForm.clickType"
    }
  }, [_vm._v("无跳转")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.advertForm.clickType),
      callback: function($$v) {
        _vm.$set(_vm.advertForm, "clickType", $$v)
      },
      expression: "advertForm.clickType"
    }
  }, [_vm._v("跳转至URL：")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.advertForm.clickType),
      callback: function($$v) {
        _vm.$set(_vm.advertForm, "clickType", $$v)
      },
      expression: "advertForm.clickType"
    }
  }, [_vm._v("跳转至已有文章：")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "3"
    },
    model: {
      value: (_vm.advertForm.clickType),
      callback: function($$v) {
        _vm.$set(_vm.advertForm, "clickType", $$v)
      },
      expression: "advertForm.clickType"
    }
  }, [_vm._v("跳转至已有话题：")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "4"
    },
    model: {
      value: (_vm.advertForm.clickType),
      callback: function($$v) {
        _vm.$set(_vm.advertForm, "clickType", $$v)
      },
      expression: "advertForm.clickType"
    }
  }, [_vm._v("跳转至已有活动：")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "5"
    },
    model: {
      value: (_vm.advertForm.clickType),
      callback: function($$v) {
        _vm.$set(_vm.advertForm, "clickType", $$v)
      },
      expression: "advertForm.clickType"
    }
  }, [_vm._v("跳转至微信小程序：")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "6"
    },
    model: {
      value: (_vm.advertForm.clickType),
      callback: function($$v) {
        _vm.$set(_vm.advertForm, "clickType", $$v)
      },
      expression: "advertForm.clickType"
    }
  }, [_vm._v("跳转至支付宝小程序：")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "7"
    },
    model: {
      value: (_vm.advertForm.clickType),
      callback: function($$v) {
        _vm.$set(_vm.advertForm, "clickType", $$v)
      },
      expression: "advertForm.clickType"
    }
  }, [_vm._v("跳转至音频：")]), _vm._v(" "), (_vm.shieldArray.indexOf(_vm.advertForm.clickType) > -1) ? _c('el-input', {
    staticClass: "bounceTitle",
    attrs: {
      "placeholder": _vm.placeholder
    },
    model: {
      value: (_vm.advertForm.targetUrl),
      callback: function($$v) {
        _vm.$set(_vm.advertForm, "targetUrl", $$v)
      },
      expression: "advertForm.targetUrl"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.advertForm.clickType == '5') ? _c('div', {
    staticClass: "wx-app"
  }, [_c('el-form-item', {
    staticClass: "wxApp-from",
    attrs: {
      "label": "小程序原始Id：",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写正确的小程序原始Id"
    },
    model: {
      value: (_vm.advertForm.wxAppId),
      callback: function($$v) {
        _vm.$set(_vm.advertForm, "wxAppId", $$v)
      },
      expression: "advertForm.wxAppId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "wxApp-from",
    attrs: {
      "label": "路径地址："
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写正确的路径地址"
    },
    model: {
      value: (_vm.advertForm.wxAppUrl),
      callback: function($$v) {
        _vm.$set(_vm.advertForm, "wxAppUrl", $$v)
      },
      expression: "advertForm.wxAppUrl"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.advertForm.clickType == '6') ? _c('div', {
    staticClass: "wx-app"
  }, [_c('el-form-item', {
    staticClass: "wxApp-from",
    attrs: {
      "label": "小程序原始Id：",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写正确的小程序原始Id"
    },
    model: {
      value: (_vm.advertForm.aliAppId),
      callback: function($$v) {
        _vm.$set(_vm.advertForm, "aliAppId", $$v)
      },
      expression: "advertForm.aliAppId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "wxApp-from",
    attrs: {
      "label": "路径地址："
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写正确的路径地址"
    },
    model: {
      value: (_vm.advertForm.aliAppUrl),
      callback: function($$v) {
        _vm.$set(_vm.advertForm, "aliAppUrl", $$v)
      },
      expression: "advertForm.aliAppUrl"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.advertForm.clickType == '7') ? _c('div', {
    staticClass: "wx-app"
  }, [_c('el-form-item', {
    staticClass: "wxApp-from",
    attrs: {
      "label": "专辑ID：",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写专辑ID"
    },
    model: {
      value: (_vm.advertForm.albumId),
      callback: function($$v) {
        _vm.$set(_vm.advertForm, "albumId", $$v)
      },
      expression: "advertForm.albumId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "wxApp-from wx-app",
    attrs: {
      "label": "主播名称：",
      "prop": "nickName",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写主播名称"
    },
    model: {
      value: (_vm.advertForm.nickName),
      callback: function($$v) {
        _vm.$set(_vm.advertForm, "nickName", $$v)
      },
      expression: "advertForm.nickName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "wxApp-from",
    attrs: {
      "label": "单曲数：",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写单曲数",
      "type": "number"
    },
    model: {
      value: (_vm.advertForm.albumCount),
      callback: function($$v) {
        _vm.$set(_vm.advertForm, "albumCount", $$v)
      },
      expression: "advertForm.albumCount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "wxApp-from",
    attrs: {
      "label": "是否付费：",
      "prop": "isPaid",
      "required": ""
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.advertForm.isPaid),
      callback: function($$v) {
        _vm.$set(_vm.advertForm, "isPaid", $$v)
      },
      expression: "advertForm.isPaid"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.advertForm.isPaid),
      callback: function($$v) {
        _vm.$set(_vm.advertForm, "isPaid", $$v)
      },
      expression: "advertForm.isPaid"
    }
  }, [_vm._v("否")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('select-school', {
    attrs: {
      "schObj": _vm.advertForm.schObj
    },
    on: {
      "changeVal": _vm.getVal
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f3db6cf8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/advert/newAdvert.vue
// module id = 1141
// module chunks = 0